import { useState } from 'react';
import api from '../../services/api';
import { Gift, Loader2, Check, AlertTriangle } from 'lucide-react';

export default function RedeemCodeInput({ onRedeemed }) {
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null); // { type: 'success'|'error', text }

    const handleRedeem = async () => {
        if (!code.trim() || code.trim().length < 19) {
            setResult({ type: 'error', text: 'Code invalide — format attendu : XXXX-XXXX-XXXX-XXXX' });
            return;
        }
        setLoading(true);
        setResult(null);
        try {
            const { data } = await api.post('/share/codes.php', {
                action: 'redeem',
                code: code.trim(),
            });
            if (data.success) {
                setResult({
                    type: 'success',
                    text: `Acces active pour « ${data.data.scope_label} » jusqu'au ${new Date(data.data.access_end).toLocaleDateString('fr-FR')}`,
                });
                setCode('');
                if (onRedeemed) onRedeemed(data.data);
            }
        } catch (e) {
            const msg = e.response?.data?.error || 'Erreur lors de l\'activation';
            setResult({ type: 'error', text: msg });
        }
        setLoading(false);
    };

    // Accepte les codes préfixés (PART-…) ET les anciens sans préfixe.
    const handleChange = (e) => {
        setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 28));
    };

    return (
        <div className="redeem-code">
            <div className="redeem-code__form">
                <Gift size={18} />
                <input
                    type="text"
                    value={code}
                    onChange={handleChange}
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                    maxLength={28}
                    className="redeem-code__input"
                    onKeyDown={(e) => e.key === 'Enter' && handleRedeem()}
                />
                <button className="btn btn-sm btn-primary" onClick={handleRedeem} disabled={loading || !code.trim()}>
                    {loading ? <Loader2 size={14} className="spin" /> : 'Activer'}
                </button>
            </div>
            {result && (
                <div className={`redeem-code__result redeem-code__result--${result.type}`}>
                    {result.type === 'success' ? <Check size={14} /> : <AlertTriangle size={14} />}
                    {result.text}
                </div>
            )}
        </div>
    );
}
